import React from "react";
import ReactEcharts from "echarts-for-react";

export const mockDataEnergy = {
  other: {
    data: [
      { key: "q1", value: 10, label: "Q1" },
      { key: "q2", value: 20, label: "Q2" },
      { key: "q3", value: 30, label: "Q3" },
      { key: "q4", value: 40, label: "Q4" },
    ],
    unit: "Kilowatthour, kWh",
  },
  lighting: {
    data: [
      { key: "q1", value: 10, label: "Q1" },
      { key: "q2", value: 20, label: "Q2" },
      { key: "q3", value: 30, label: "Q3" },
      { key: "q4", value: 40, label: "Q4" },
    ],
    unit: "Kilowatthour, kWh",
  },
  hvac: {
    data: [
      { key: "q1", value: 5, label: "Q1" },
      { key: "q2", value: 20, label: "Q2" },
      { key: "q3", value: 30, label: "Q3" },
      { key: "q4", value: 40, label: "Q4" },
    ],
    unit: "Kilowatthour, kWh",
  },
};

export const mockDataWaste = {
  general: {
    data: [
      { key: "q1", value: 10, label: "Q1" },
      { key: "q2", value: 20, label: "Q2" },
      { key: "q3", value: 30, label: "Q3" },
      { key: "q4", value: 40, label: "Q4" },
    ],
    unit: "Kilowatthour, kWh",
  },
  recycle: {
    data: [
      { key: "q1", value: 10, label: "Q1" },
      { key: "q2", value: 20, label: "Q2" },
      { key: "q3", value: 30, label: "Q3" },
      { key: "q4", value: 40, label: "Q4" },
    ],
    unit: "Kilowatthour, kWh",
  },
  organic: {
    data: [
      { key: "q1", value: 10, label: "Q1" },
      { key: "q2", value: 20, label: "Q2" },
      { key: "q3", value: 30, label: "Q3" },
      { key: "q4", value: 40, label: "Q4" },
    ],
    unit: "Kilowatthour, kWh",
  },
  hazard: {
    data: [
      { key: "q1", value: 10, label: "Q1" },
      { key: "q2", value: 20, label: "Q2" },
      { key: "q3", value: 30, label: "Q3" },
      { key: "q4", value: 40, label: "Q4" },
    ],
    unit: "Kilowatthour, kWh",
  },
};

type BarChartProps = {
  data: {
    [key: string]: {
      data: { key: string; value: number; label: string }[];
      unit: string;
      color: string;
    };
  };
  title: string;
  yAxisName: string;
  height: string;
};

export const BarChart: React.FC<BarChartProps> = ({
  data,
  title,
  yAxisName,
  height,
}) => {
  const options = {
    title: {
      text: title,
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    legend: {
      data: Object.keys(data),
      //   orient: 'vertical',
      bottom: "5%",
    },
    // legend: {
    //     data: data.length > 0 ? data.map((dataset) => dataset.name) : [],
    //     bottom: "5%",
    //   },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "15%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        data: data[Object.keys(data)[0]]?.data.map((item) => item.label),
      },
    ],
    yAxis: [
      {
        type: "value",
        name: yAxisName,
      },
    ],
    series: Object.keys(data).map((key) => ({
      name: key,
      type: "bar",
      data: data[key].data.map((item) => item.value),
      itemStyle: {
        color: data[key].color, // Apply color
        borderRadius: [8, 8, 0, 0], // Rounded corners for a rounded bar only for index 1
      },
      emphasis: {
        focus: "series",
      },
      label: {
        show: true,
        position: "top",
        fontSize: 14, // Increased font size for larger text
        formatter: function (params: any) {
          return params.value?.toLocaleString(undefined, {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
          }); // Format value to 2 decimal places
        },
      },
    })),
  };

  return (
    <ReactEcharts option={options} style={{ height: height, width: "100%" }} />
  );
};
